// extracted by mini-css-extract-plugin
module.exports = {"radarContainer":"ResultsRadarChart_radarContainer__B6gGd"};